import { authHeader, handleResponse } from '../helpers'

export const eventService = {
  getEvents,
  getEvent,
  createEvent,
  copyEvent,
  updateEvent,
  deleteEvent,
  createEventFromTemplate,
  getEventTemplates
}

function getEvents() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(process.env.VUE_APP_API_URL + '/event', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var events = response.events
      return events
    })
}

function getEvent(eventId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/event/' + eventId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var event = response
      return event
    })
}

function createEvent(eventData) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: eventData
  }
  return fetch(process.env.VUE_APP_API_URL + '/event', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var event = response
      return event
    })
}

function getEventTemplates() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(process.env.VUE_APP_API_URL + '/event/templates', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var templates = response
      return templates
    })
}

function createEventFromTemplate(eventData) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(eventData)
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/event/fromTemplate',
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var event = response
      return event
    })
}

function copyEvent(eventId, eventData) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: eventData
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/event/' + eventId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var event = response
      return event
    })
}

function updateEvent(eventId, eventData) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: eventData
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/event/' + eventId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var event = response
      return event
    })
}

function deleteEvent(eventId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/event/' + eventId,
    requestOptions
  )
    .then((res) => res.text())
    .then((res) => {
      var event = res
      return event
    })
}
